import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Ruta protegida: sin sesión válida redirige a /admin/login; con `roles`, un usuario de otro rol
// vuelve al inicio del panel (la API rechaza igualmente la petición: esto sólo evita pantallas vacías).
const PrivateRoute = ({ component: Component, children, roles, ...rest }) => {
  const { isAuthenticated, usuario } = useAuth();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isAuthenticated()) {
          return <Redirect to={{ pathname: '/admin/login', state: { from: props.location } }} />;
        }
        if (roles && (!usuario || !roles.includes(usuario.rol))) {
          return <Redirect to="/admin" />;
        }
        return Component ? <Component {...props} /> : children;
      }}
    />
  );
};

export default PrivateRoute;
